import { useQuery } from 'src/core/api/hooks/useQuery';
import { type QueryState } from 'src/core/api/queryState';

export type MCRLimit = {
  limited: boolean;
  limit: number;
  alreadyUsed: number;
};

export const defaultMCRLimit: MCRLimit = {
  limited: true,
  limit: 0,
  alreadyUsed: 0,
};

export const getPayableRulesMCRLimitQueryKey = [
  'bookkeeping',
  'automation',
  'payable-rules',
  'limit',
];
export const useGetPayableRulesMCRLimit = (): QueryState<{
  limited: boolean;
  limit: number;
  alreadyUsed: number;
}> => {
  return useQuery({
    key: getPayableRulesMCRLimitQueryKey,
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/bookkeeping/automation/payable-rules/limit`,
    },
    reshapeData: (data) => {
      return data.result.mcr;
    },
  });
};
